import React from "react";
import styles from "../Channels.module.scss";
import TelegramIcon from "../../../../assets/icons/TelegramIcon";
import { Switch } from "antd";

import { useTranslation } from "react-i18next";
import CustomButton from "../../../CustomButton/CustomButton";

const ChannelItem = ({ data }) => {
  const { t } = useTranslation();

  return data && data.length > 0 ? (
    <div className={styles.channelItems}>
      {data.map((item, idx) => (
        <div className={styles.channelItem} key={idx}>
          <TelegramIcon size={30} />
          <h3>{item.bot_username}</h3>
          <div>
            {t("channels.channelActive")} <Switch value={item.is_active} />
          </div>
          <CustomButton blue>{t("channels.editButton")}</CustomButton>
        </div>
      ))}
    </div>
  ) : (
    <p>{t("channels.noChannels")}</p>
  );
};

export default ChannelItem;
